module.exports = __webpack_public_path__ + "static/media/roulette3.873314cb.png";